import React, { useEffect, useState } from "react";
import CustomTable from "../../components/customtable/CustomTable";
import Breadcrumb from "../../components/common/Breadcrumb";
import DebounceSearch from "../../components/common/DebounceSearch";
import Action from "../../components/common/Action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteMovement, getMovementlist } from "../../redux/movement/slice";
import RippleLoader from "../../components/RippleLoader/RippleLoader";
import ConfirmationModel from "../../components/common/ConfirmationModel";
import { SortDownArrow } from "../../assets/svg";

const Movement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [movementDelete, setMovementDelete] = useState(null);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [isLoading, setIsLoading] = useState(false);

  // selector
  const { movementList, movementListLoading } = useSelector((store) => ({
    movementList: store?.movementData?.getMovementlistStatus?.data?.data,
    movementListLoading: store?.movementData?.loading,
  }));

  useEffect(() => {
    dispatch(
      getMovementlist({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
      })
    );
  }, [dispatch, searchValue, pageCount, pageLimit, sortBy, sortDirection]);

  // Delete movement
  const deleteMovementId = () => {
    setIsLoading(true);
    if (!movementDelete) return;
    dispatch(deleteMovement(movementDelete)).then((res) => {
      setIsLoading(false);
      if (res.type === "deleteMovement/fulfilled") {
        dispatch(
          getMovementlist({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
          })
        );
      }
      setConfirmDelete(false);
    });
  };
  // Table Headers
  const ColumnHeaders = () => (
    <>
      <th className="w-16 table-th">No.</th>
      <th className="w-20 table-th">Image</th>
      <th className="table-th">
        <div
          className="flex items-center cursor-pointer gap-1 select-none"
          onClick={() => {
            setSortBy("movementName");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Name</span>
          <span
            className={`transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "movementName"
                ? "rotate-180"
                : "rotate-0"
            }`}
          >
            <SortDownArrow />
          </span>
        </div>
      </th>
      <th className="table-th">
        <div
          className="flex items-center cursor-pointer gap-1 select-none"
          onClick={() => {
            setSortBy("title");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Title</span>
          <span
            className={`transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "title"
                ? "rotate-180"
                : "rotate-0"
            }`}
          >
            <SortDownArrow />
          </span>
        </div>
      </th>
      <th className="table-th">Impact</th>
      <th className="table-th">Equipment</th>
      <th className="w-20 table-th">
        <div
          className="flex items-center cursor-pointer gap-1 select-none"
          onClick={() => {
            setSortBy("calories");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Calories</span>
          <span
            className={`transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "calories"
                ? "rotate-180"
                : "rotate-0"
            }`}
          >
            <SortDownArrow />
          </span>
        </div>
      </th>
      <th className="w-20 table-th">Time</th>
      <th className="w-20 table-th">Actions</th>
    </>
  );

  // Table Rows
  const DataRows = () => (
    <>
      {(movementList?.data || []).map((item, index) => (
        <tr key={item.id} className=" shadow-sm text-mgrey hover:bg-navTheme/5">
          <td className="px-5 py-3">
            {(pageCount - 1) * pageLimit + index + 1}
          </td>
          <td className="px-5 py-3">
            {item?.coverImage ? (
              <img
                src={item?.coverImage}
                alt="Document"
                className="w-10 h-10 object-cover"
              />
            ) : (
              "-"
            )}
          </td>
          <td className="px-5 py-3">
            <div className="line-clamp-1">{item?.movementName || "-"}</div>
          </td>
          <td className="px-5 py-3">{item?.title || "-"}</td>
          <td className="px-5 py-3">{item?.impact || "-"}</td>
          <td className="px-5 py-3">{item?.equipment || "-"}</td>
          <td className="px-5 py-3">{item?.calories || "-"}</td>
          <td className="px-5 py-3">{item?.selecttime || "-"}</td>
          <td className="flex px-5 py-3">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() =>
                      navigate("/add-edit-movement", {
                        state: { movement: item, mode: "edit" },
                      })
                    }
                  >
                    View/Edit
                  </li>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => {
                      setConfirmDelete(true);
                      setMovementDelete(item?._id);
                    }}
                  >
                    Delete
                  </li>
                </>
              }
            />
          </td>
        </tr>
      ))}
    </>
  );
  return (
    <>
      <div className="space-y-5">
        <div>
          <h6 className="font-Montserrat font-medium text-xl mb-3">Movement</h6>
        </div>
        <Breadcrumb
          breadCrumbParent={"Home"}
          breadCrumbActive={"Movement"}
          breadCrumbTitleKey={"/"}
          classes=""
        />
        <div className="flex items-center space-x-4 w-full">
          <DebounceSearch
            className="full-width"
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
          <button
            className="bg-themeBtn text-white flex items-center justify-center px-2 py-[7px] rounded uppercase font-Proxima text-base w-40 shadow-[0_4px_6px_rgba(0,0,0,0.3)]"
            onClick={() => {
              navigate("/add-edit-movement");
            }}
            type="button"
          >
            + Add
          </button>
        </div>
        <div className="w-full bg-white shadow rounded-lg">
          {movementListLoading ? (
            <RippleLoader />
          ) : (
            <CustomTable
              overflowVisibleLg={true}
              columnHeaders={<ColumnHeaders />}
              dataRows={<DataRows />}
              data={movementList}
              loading={false}
              showPagination={true}
              disableNext={!!movementList?.data?.length}
              disablePrev={!!movementList?.data?.length}
              setPaginationCurrentLimit={setPageLimit}
              paginationCurrentLimit={pageLimit}
              current={pageCount}
              total={movementList?.pagination?.total}
              paginationData={(crPage) => setPageCount(crPage)}
              lastPage={Math.ceil(movementList?.pagination?.total / pageLimit)}
            />
          )}
        </div>
      </div>
      {confirmDelete && (
        <div>
          <ConfirmationModel
            confirmText={"Delete"}
            onClose={() => {
              setConfirmDelete(false);
            }}
            onConfirm={deleteMovementId}
            isLoading={isLoading}
          />
        </div>
      )}
    </>
  );
};

export default Movement;
